<template>
    <div>
        <div id="page" class="hfeed site" style="margin-left:auto;margin-right:auto;">
            <div class="fixed-top" style="max-width:1260px;margin-left:auto;margin-right:auto">
                <div id="site-header">
                    <a href="/" rel="home">
                        <img
                            src="/images/cropped-sonsak.png"
                            width="1260"
                            height="130"
                            alt="Kionier"
                        />
                    </a>
                </div>

                <header id="masthead" class="site-header" role="banner">
                    <div class="header-main">
                        <h1 class="site-title">
                            <a href="/" rel="home">Kionier</a>
                        </h1>

                        <div class="search-toggle">
                            <a
                                href="#search-container"
                                class="screen-reader-text"
                                aria-expanded="false"
                                aria-controls="search-container"
                            >Search</a>
                        </div>

                        <nav
                            id="primary-navigation"
                            class="site-navigation primary-navigation"
                            role="navigation"
                        >
                            <button class="menu-toggle">Primary Menu</button>
                            <a class="screen-reader-text skip-link" href="#content">Skip to content</a>
                            <div class="menu-top-container">
                                <ul id="primary-menu" class="nav-menu">
                                    <li
                                        id="menu-item-24"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-24"
                                    >
                                        <a href="/about/">About</a>
                                    </li>
                                    <!-- <li
                                        id="menu-item-64"
                                        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-64"
                                    >
                                        <a href="http://kionier.com/d2x/">D2X</a>
                                    </li>-->
                                </ul>
                            </div>
                        </nav>
                    </div>

                    <!-- <div id="search-container" class="search-box-wrapper hide">
                        <div class="search-box">
                            <form
                                role="search"
                                method="get"
                                class="search-form"
                                action="http://kionier.com/"
                            >
                                <label>
                                    <span class="screen-reader-text">Search for:</span>
                                    <input
                                        type="search"
                                        class="search-field"
                                        placeholder="Search &hellip;"
                                        value
                                        name="s"
                                    />
                                </label>
                                <input type="submit" class="search-submit" value="Search" />
                            </form>
                        </div>
                    </div>-->
                </header>
                <!-- #masthead -->
            </div>

            <div id="main" class="site-main">
                <div id="main-content" class="main-content">
                    <div id="primary" class="content-area">
                        <div id="content" class="site-content" role="main">
                            <article
                                id="post-67"
                                class="post-67 page type-page status-publish hentry"
                            >
                                <div class="entry-content">
                                    <div style="min-height: 100%;">
                                        <router-view />
                                    </div>
                                </div>
                                <!-- .entry-content -->
                            </article>
                            <!-- #post-## -->
                        </div>
                        <!-- #content -->
                    </div>
                    <!-- #primary -->
                </div>
                <!-- #main-content -->

                <!-- <div id="secondary" style="display:none !important">
                    <div
                        id="primary-sidebar"
                        class="primary-sidebar widget-area"
                        role="complementary"
                    >
                        <aside id="search-2" class="widget widget_search">
                            <form
                                role="search"
                                method="get"
                                class="search-form"
                                action="http://kionier.com/"
                            >
                                <label>
                                    <span class="screen-reader-text">Search for:</span>
                                    <input
                                        type="search"
                                        class="search-field"
                                        placeholder="Search &hellip;"
                                        value
                                        name="s"
                                    />
                                </label>
                                <input type="submit" class="search-submit" value="Search" />
                            </form>
                        </aside>
                        <aside id="blog_subscription-2" class="widget jetpack_subscription_widget">
                           
                        </aside>
                    </div> -->
                    <!-- #primary-sidebar 
                </div> -->
                <!-- #secondary -->
            </div>
            <!-- #main -->

            <footer id="colophon" class="fixed-bottom" role="contentinfo">
                <div class="site-footer" style="max-width:1260px;margin-left:auto;margin-right:auto">
                    <div>
                        <div class="site-info" style="float: left;">
                            © 2020 KIONIER – All rights reserved
                        </div>
                        <div class="site-info" style="float right; text-align:right ;">
                            <a href="/privacy-policy" title="Privacy Policy">
                                Privacy Policy
                            </a>
                        </div>
                    </div>
                </div>
                <!-- .site-info -->
            </footer>
            <!-- #colophon -->
        </div>
        <!-- #page -->

        <div style="display:none"></div>
    </div>
</template>

<style>
a {
    outline: 0 !important;
}
a:hover {
    text-decoration: none !important;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
/*@import './assets/styles/yourstyles.css';
@import "//fonts.googleapis.com/css?family=Source+Sans+Pro";
@import "/css/fontawesome-all.min.css?ver=4.1.39";
@import "/css/style.min.css?ver=5.2.5";
@import "/css/cstyle.min.css?ver=4.1.39";*/

@import "/css/twentyfourteen.css?ver=5.3.1";
@import "/css/style.css?ver=4.8.12";
@import "/css/bootstrap.css";
/* @import "/css/genericons.css?ver=3.1";
@import "//fonts.googleapis.com/css?family=Lato%3A300%2C400%2C700%2C900%2C300italic%2C400italic%2C700italic&#038;subset=latin%2Clatin-ext"; */
</style>

<!-- import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BCarousel,BCarouselSlide } from 'bootstrap-vue'
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide) -->

<script>
export default {
    data() {
        return {
            showmenu: false
        };
    }
};
</script>
